import { Link } from "react-router-dom";
import { AlertTriangle, ArrowUpRight } from "lucide-react";
import { Panel } from "@/components/ui/Panel";
import { SaveBar, Toggle } from "@/components/ui/Form";
import { ErrorState, Skeleton } from "@/components/ui/states";
import { friendlyError } from "@/lib/errors";
import type { StoreSettings } from "./storeApi";
import { useSettingsForm } from "./useSettingsForm";

const desdeAjustes = (a: StoreSettings) => ({
  delivery_enabled: Boolean(a.delivery_enabled),
  pickup_enabled: Boolean(a.pickup_enabled),
});

/**
 * Solo dos interruptores, y es correcto que sean solo dos.
 *
 * Aqui se decide QUE modalidades acepta la tienda. A donde reparte y por
 * cuanto es otra cosa y vive en Entregas: son decisiones de distinta
 * frecuencia —esto se toca una vez, las tarifas cambian cada temporada— y
 * juntarlas obligaria a pasar por una pantalla larga para algo de un clic.
 */
export function DeliveryPage() {
  const { consulta, borrador, set, sucio, guardando, guardar, descartar } =
    useSettingsForm(desdeAjustes);

  if (consulta.isPending || !borrador) return <Skeleton className="h-64 w-full rounded-lg" />;
  if (consulta.isError) {
    return (
      <ErrorState
        message={friendlyError(consulta.error)}
        onRetry={() => void consulta.refetch()}
      />
    );
  }

  const ninguna = !borrador.delivery_enabled && !borrador.pickup_enabled;

  return (
    <div className="flex flex-col gap-3">
      {ninguna && (
        <div className="flex items-start gap-2.5 rounded-lg border border-crit bg-crit-soft px-4 py-3">
          <AlertTriangle className="mt-0.5 size-4 shrink-0 text-crit" />
          <p className="text-meta text-ink">
            Sin delivery ni recojo, nadie puede terminar una compra. La tienda queda
            como catálogo.
          </p>
        </div>
      )}

      <Panel title="Modalidades de entrega">
        <div className="flex flex-col gap-2.5">
          <Toggle
            label="Delivery a domicilio"
            hint="El comprador elige su distrito y se le cobra la tarifa correspondiente."
            checked={borrador.delivery_enabled}
            onChange={(v) => set("delivery_enabled", v)}
          />
          <Toggle
            label="Recojo en tienda"
            hint="Sin costo de envío. Se le muestra la dirección y el horario de Identidad."
            checked={borrador.pickup_enabled}
            onChange={(v) => set("pickup_enabled", v)}
          />
        </div>

        <Link
          to="/entregas"
          className="mt-4 inline-flex items-center gap-1 text-meta font-medium text-accent hover:underline"
        >
          Distritos y tarifas de reparto
          <ArrowUpRight className="size-3.5" />
        </Link>
      </Panel>

      <SaveBar
        dirty={sucio}
        saving={guardando}
        onSave={() =>
          void guardar({
            delivery_enabled: borrador.delivery_enabled,
            pickup_enabled: borrador.pickup_enabled,
          })
        }
        onReset={descartar}
      />
    </div>
  );
}
